<template>
  <div v-if="isLoading || !isEdit || !empty(careVideoInfo)">
    <a-card class="style1 category w-100" :class="[isDesktop ? 'desktop' : 'mobile']">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item label="Title">
          <a-input
            @change="onGenerateSlug"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input title!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Slug">
          <a-input
            v-decorator="[
              'slug',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input category slug!',
                  },
                ],
              },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="Description">
          <wysiwyg
            v-model="description"
            v-decorator="[
              'description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input Description!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Player">
          <a-row :gutter="20">
            <a-col :span="isDesktop ? 8 : 24">
              <a-textarea v-decorator="['player']" :rows="10" @change="onChangePlayerEmbed" />
              <a-button type="primary" :disabled="empty(player)" @click.prevent="showEmbedPreview">{{ showPreview ? 'Hide preview' : 'Preview' }}</a-button>
            </a-col>
            <a-col :span="isDesktop ? 16 : 24">
              <div v-if="showPreview" v-html="player"></div>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="Thumbnail">
          <a-upload
            v-decorator="['thumbnail']"
            action
            list-type="picture-card"
            :file-list="thumbnail"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'thumbnail')"
            @change="({ fileList }) => handleChange({ fileList }, 'thumbnail')"
            class="thumbnail"
          >
            <div v-if="thumbnail.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="Category">
          <a-select
            allowClear
            show-search
            :filter-option="filterOption"
            option-filter-prop="children"
            v-decorator="[
              'care_category_id',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please select Category!'),
                  },
                ],
              },
            ]"
          >
            <a-select-option :value="category.id" :key="category.id" v-for="category in categories">{{ category.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Speaker Bio">
          <a-select
            allowClear
            show-search
            :filter-option="filterOption"
            option-filter-prop="children"
            v-decorator="[
              'care_speaker_bio_id',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please select Speaker Bio!'),
                  },
                ],
              },
            ]"
          >
            <a-select-option :value="speaker.id" :key="speaker.id" v-for="speaker in speakerBio">{{ speaker.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 20, offset: 4 }">
          <a-tag color="red" class="d-block p-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ isEdit ? 'Update Video' : 'Create Video' }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal :visible="previewVisible" :closable="false" class="editProfile">
      <a-spin v-if="isLoadingCropper" size="large" />
      <cropper
        v-if="previewImage != null && !fixCroppedImageSize"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="change"
        @ready="onCropperReady"
        :defaultSize="defaultSize"
        :defaultPosition="defaultPosition"
      />
      <cropper
        v-if="previewImage != null && fixCroppedImageSize"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="change"
        @ready="onCropperReady"
        :stencil-size="{ width: 350, height: 200 }"
        :stencil-props="{ aspectRatio: 1.75 }"
      />
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button key="submit" type="primary" @click="handleOk">Submit</a-button>
      </template>
    </a-modal>
    <Loading :isLoading="isLoading" :type="typeLoading" :percent="percentLoading" />
  </div>
  <div v-else>
    <h2>Video not found</h2>
    <a-button type="primary" class="mb-3" @click="$router.push({ name: 'AdminCareVideo' })">Go to videos list</a-button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import Uploader from '@/services/UploadService';
import AdminService from '@/services/AdminService';
import Loading from '@/views/profile/loading';
import { empty, slugData, getBase64 } from '@/utils';
import { get, find } from 'lodash';
export default {
  components: {
    Cropper,
    Loading,
  },
  data() {
    return {
      showPreview: false,
      error: '',
      careVideoInfo: {},
      speakerBio: [],
      categories: [],
      isLoading: false,
      imagePickerVisible: false,
      previewVisible: false,
      isLoadingCropper: false,
      previewImage: '',
      embedIcon: [],
      embedThumbnail: [],
      background: [],
      thumbnail: [],
      imgLocation: '',
      imageCropped: '',
      hasChange: {},
      hasCropped: {},
      description: '',
      player: '',
      typeLoading: 'submit',
      percentLoading: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'careVideo',
    });
  },
  computed: {
    ...mapState(['settings']),
    isEdit() {
      return this.$route.name === 'AdminCareVideoDetail';
    },
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    fixCroppedImageSize() {
      return this.imgLocation === 'thumbnail';
    },
  },
  watch: {
    $route: {
      async handler(route) {
        if (this.isEdit) {
          this.doGetCareVideoInfo(route.params.careVideoSlug);
        }
        this.speakerBio = await AdminService.careSpeakerBio.getAll();
        this.categories = await AdminService.careCategory.getAll();
      },
      immediate: true,
    },
  },
  mounted() {
    this.$title = this.$route.meta.title;
  },
  methods: {
    empty,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onGenerateSlug() {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          slug: slugData(this.form.getFieldValue('title'), '-'),
        });
      });
    },
    onChangePlayerEmbed(val) {
      this.playerembed = this.form.getFieldValue('playerembed');
    },
    showEmbedPreview() {
      if (this.showPreview) {
        this.showPreview = false;
      } else {
        this.player = this.form.getFieldValue('player');
        this.showPreview = true;
      }
    },
    async doGetCareVideoInfo(careVideoSlug) {
      try {
        this.isLoading = true;
        const resp = await AdminService.careVideo.getAll();
        this.careVideoInfo = find(resp, item => item.slug === careVideoSlug);
        this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },

    async doInitData() {
      if (this.isEdit) {
        this.description = this.careVideoInfo.description;
        this.player = this.careVideoInfo.player;
        this.thumbnail = [];
        this.showPreview = !empty(this.player);
        // eslint-disable-next-line camelcase
        const { thumbnail } = this.careVideoInfo;

        if (!empty(thumbnail)) {
          this.thumbnail.push({
            uid: '-1',
            status: 'done',
            name: this.getFileName(thumbnail),
            url: thumbnail,
          });
        }

        this.$nextTick(() => {
          this.form.setFieldsValue({
            title: this.careVideoInfo.title,
            slug: this.careVideoInfo.slug,
            player: this.careVideoInfo.player,
            care_speaker_bio_id: this.careVideoInfo.care_speaker_bio_id,
            care_category_id: this.careVideoInfo.care_category_id,
            description: this.description,
            thumbnail: this.thumbnail[0],
          });
        });
      }
    },
    defaultSize() {
      return {
        width: 10000,
        height: 10000,
        minHeight: 250,
        minWidth: 190,
      };
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    defaultPosition() {
      return {
        left: 0,
        top: 0,
      };
    },
    getFileName(path) {
      let fileName = '';
      // eslint-disable-next-line no-useless-escape
      const patt = /\/([^\\\/:*\"<>|]+)$/g;
      const n = patt.exec(path);
      if (n !== null) {
        fileName = n[1];
      }
      return fileName;
    },
    change({ canvas }) {
      if (canvas) {
        if (this.fixCroppedImageSize && canvas.width !== 350) {
          const newCanvas = document.createElement('canvas');
          newCanvas.width = 350;
          newCanvas.height = 200;
          const newCtx = newCanvas.getContext('2d');
          newCtx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, newCanvas.width, newCanvas.height);
          canvas = newCanvas;
        }

        this.imageCropped = canvas.toDataURL('image/jpeg');
      }
    },
    handleUploadProgressing(percent, location) {
      this.percentLoading = percent;
      this.typeLoading = location;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            this.error = '';
            // upload image
            const dataSubmit = {};

            if (this.hasChange['thumbnail'] || this.hasCropped['thumbnail']) {
              this.handleUploadProgressing(0, 'Thumbnail');
              const thumbnailContent = this.thumbnail[0];
              let thumbnail = {
                contentType: thumbnailContent.type, // you can set it based on the type of image you are uploading like image/png
                fileName: thumbnailContent.name,
                file: thumbnailContent.preview,
              };
              const respthumbnail = await new Uploader().uploadImage(thumbnail, percent => this.handleUploadProgressing(percent, 'Thumbnail'));
              dataSubmit['thumbnail'] = respthumbnail.Location;
            } else if (!empty(values['thumbnail'])) {
              dataSubmit['thumbnail'] = values['thumbnail'].url;
            }

            const paramsRequired = ['description', 'title', 'slug', 'player', 'care_speaker_bio_id', 'care_category_id'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            this.typeLoading = 'submit';
            if (!this.isEdit) {
              await AdminService.careVideo.create(dataSubmit);
              this.$notification['success']({
                message: 'Create successful.',
                description: `${dataSubmit.name} was created successfully.`,
              });
            } else {
              await AdminService.careVideo.update(this.careVideoInfo.id, dataSubmit);
              this.$emit('onSuccess');
              this.$notification['success']({
                message: 'Update successful.',
                description: `${dataSubmit.name} was updated successfully.`,
              });
            }
            this.$router.push({ name: 'AdminCareVideo' });
          } catch (error) {
            console.log(error);
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
      this.imageCropped = null;
      if (this.hasChange[this.imgLocation]) {
        switch (this.imgLocation) {
          case 'thumbnail':
            this.thumbnail = [];
            break;
        }
      }
    },
    handleOk() {
      switch (this.imgLocation) {
        case 'thumbnail':
          this.thumbnail = [
            {
              ...this.thumbnail[0],
              preview: this.imageCropped,
              thumbUrl: this.imageCropped,
            },
          ];
          break;
      }
      this.$set(this.hasCropped, this.imgLocation, true);
      this.previewVisible = false;
    },
    handlePreview(file, location) {
      this.imgLocation = location;
      this.previewImage = null;
      this.$nextTick(async () => {
        this.isLoadingCropper = true;
        if (this.hasChange[location] || this.hasCropped[location]) {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
          }
          this.previewImage = file.preview;
        } else {
          this.previewImage = file.url;
        }
        this.previewVisible = true;
      });
    },
    handleChange({ fileList }, location) {
      this.imgLocation = location;
      if (!empty(fileList)) {
        this.$set(this.hasChange, location, true);
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          // const { minWidth, minHeight } = this.defaultSize();
          // if (image.height < minHeight || image.width < minWidth) {
          //   this.$notification['error']({
          //     message: 'Image error',
          //     description: `Please choose image have size greater ${minHeight}px,${minWidth}px (height,width)`,
          //   });
          //   return;
          // }
          switch (location) {
            case 'thumbnail':
              this.thumbnail = fileList;
              break;
          }
          this.handlePreview(fileList[0], location);
        };
      } else {
        switch (location) {
          case 'thumbnail':
            this.thumbnail = [];
            this.form.setFieldsValue({
              thumbnail: {},
            });
            break;
        }
      }
    },
    beforeUpload(file) {
      return false;
    },
    onCropperReady() {
      this.isLoadingCropper = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
<style lang="scss">
.category {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
    .ant-card-body {
      .ant-upload-list-item-actions {
        left: 25px;
        top: calc(100% + 20px);
        opacity: 1;
        i {
          color: rgba(#000, 0.8);
          opacity: 1;
          font-size: 20px;
        }
        > a {
          margin-right: 10px;
        }
      }
    }
  }
  .ant-card-body {
    .embedIcon {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 937px;
        max-height: 341px;
      }
    }
    .background {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 190px;
        max-height: 250px;
      }
    }
    .ant-upload-list-item-actions {
      i {
        font-size: 26px;
        width: auto;
      }
    }
  }
}
.ant-modal-root.editProfile .ant-modal-body {
  .ant-spin-spinning {
    display: block;
    margin: auto;
  }
}
.select-from-gallery {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  > span {
    width: initial;
  }
}
</style>
